export const QUICK_DEPOSIT = 'QUICK_DEPOSIT';
export const DEPOSIT = 'DEPOSIT';
export const NONE = '';
